export const convertV1Reply = ({
  value,
  userName,
  shopName,
}: {
  value: string;
  userName: string;
  shopName: string;
}) => {
  return value.replace(/\(닉네임\)/g, userName).replace(/\(매장명\)/g, shopName);
};

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // 모든 메타 문자 앞에 백슬래시를 추가
};

export const reverseV1Reply = ({
  value,
  userName,
  shopName,
}: {
  value: string;
  userName: string;
  shopName: string;
}) => {
  if (!userName || !shopName) return value;

  const userNameEscaped = escapeRegExp(userName);
  const shopNameEscaped = escapeRegExp(shopName);

  const regExp = new RegExp(userNameEscaped, 'g');
  const regExp2 = new RegExp(shopNameEscaped, 'g');

  return value.replace(regExp, '(닉네임)').replace(regExp2, '(매장명)');
};
